import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

// eslint-disable-next-line react/prop-types
function ScrollToTop({ history }) {
    useEffect(() => {
        // eslint-disable-next-line react/prop-types
        const unlisten = history.listen(() => {
            // Smooth behaviour from smoothscroll.polyfill() in index.js
            window.scroll({ top: 50, left: 0, behavior: 'smooth' });
        });
        return () => {
            unlisten();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
}

export default withRouter(ScrollToTop);
